import Icon from "@ch/components/Icons/Icon";
import EllipsesLoader from "@ch/components/Loaders/Ellipses";
import useResendConsentEmail from "../hooks/useResendConsentEmail";

const AwaitingApproval = () => {
  const { sendReminder, isLoading } = useResendConsentEmail();

  return (
    <div className="w-[460px] rounded-3xl border-2 border-[#FD6E5E4D] bg-white px-8 pb-8 pt-11 shadow-sm">
      <div className="mb-3 flex items-center justify-center">
        <div className="flex h-[85px] w-[85px] items-center justify-center rounded-full bg-[#FFE9E6]">
          <Icon color="#FD6E5E" name="alert-circle" size={44} />
        </div>
      </div>

      <h2 className="mb-2 text-center text-2xl font-semibold text-ink-900">
        Waiting for Parental Consent
      </h2>
      <p className="mb-[60px] px-4 text-center text-sm leading-6 text-ink-600">
        We&apos;re currently awaiting your parental consent approval. Once
        it&apos;s received, we&apos;ll send you a notification.
      </p>

      <button
        className="w-full rounded-xl bg-[#FD6E5E] px-4 py-3 text-white transition-opacity hover:opacity-90 disabled:cursor-not-allowed disabled:opacity-60"
        disabled={isLoading}
        onClick={() => void sendReminder()}
        type="button"
      >
        {isLoading ? (
          <EllipsesLoader contentContainerStyle="bg-white" />
        ) : (
          "Send Reminder"
        )}
      </button>
    </div>
  );
};

export default AwaitingApproval;
